<template>
  <div class="autocomplete">
    <input type="text" @keyup="query" v-on:blur="clickOut"
      v-model="keyInput" :disabled="extra.disabled || loading"
      :class="{'input':true, 'loading':loading, 'has-error':!!extra.error}" />
    <span class="error-msg">{{ extra.error }}</span>
    <i class="fa fa-spinner fa-spin loader fa-2x" v-show="loading"></i>
    <transition name="slide-down">
      <ul class="suggestions" v-show="showSuggestion">
        <li v-for="(item, index) in suggestions" @click="selectLocation(index)"
          :class="{'empty':item.title === 'Sorry'}" :key="index">
          <i v-bind:class="['fas', item.icon]"></i>
          <span>{{item.title + ', ' + item.subtitle}}</span>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')

export default {
  name: 'location-input',
  props: ['value', 'extra'],
  data () {
    return {
      initData: '',
      keyInput: '',
      // autocomplete: new google.maps.places.AutocompleteService(), // eslint-disable-line no-undef
      // geocoder: new google.maps.Geocoder(), // eslint-disable-line no-undef
      queryToken: null,
      suggestions: [],
      showSuggestion: false,
      loading: false,
      clickOutDelay: '',
      lastSelected: {}
    }
  },
  computed: {
  },
  methods: {
    query () {
      let self = this

      let queryText = self.keyInput
      if (queryText === '') {
        self.queryToken = null
        self.suggestions = []
        self.showSuggestion = false
        return
      }

      // self.generateQueryToken()

      self.showSuggestion = true
      const restrictedTypes = [
        'locality', 'postalCodePoint', 'administrativeArea',
        'chainQuery', 'categoryQuery'
      ]

      let url = 'https://autosuggest.search.hereapi.com/v1/autosuggest?at={AT}&q={SEARCH}&apiKey={API_KEY}&lang=en-US'
      url = url.replace('{AT}', encodeURIComponent(33.942791 + ',' + -118.410042))
        .replace('{SEARCH}', queryText)
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err || body.items.length === 0) {
          self.suggestions = [{
            icon: 'fa-exclamation-triangle',
            title: 'Sorry',
            subtitle: 'We coudn\'t locate "' + queryText + '"'
          }]
          return
        }

        let result = []
        body.items.forEach(function (prediction) {
          if (restrictedTypes.indexOf(prediction.resultType) === -1) {
            let subtitle = prediction.address.label
            result.push({
              id: prediction.id,
              title: prediction.title,
              subtitle: subtitle,
              icon: 'fa-map-marker'
            })
          }
        })

        self.suggestions = result.slice(0, 5)
      })
    },
    selectLocation (index) {
      let self = this
      let place = self.suggestions[index]
      self.queryToken = null

      clearTimeout(this.clickOutDelay)
      self.showSuggestion = false
      self.loading = true

      let url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}&lang=en-US'
      url = url.replace('{LOCATION_ID}', place.id)
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('geocode ERROR', results, status)
          self.loading = false
          return
        }

        let result = body
        let lat = result.position.lat
        let lng = result.position.lng
        let finalResult = {
          title: result.title,
          address1: result.address.street || result.title,
          address2: result.address.houseNumber || result.address.district,
          city: result.address.city,
          state: result.address.state,
          zip: result.address.postalCode,
          country: result.address.countryCode,
          lat: lat,
          lng: lng
        }

        self.keyInput = finalResult.title
        self.lastSelected = finalResult

        if (self.extra.field === 'extraStop') {
          self.$store.commit('rsvpDetails/setExtraStopData', {
            id: self.extra.id,
            fields: finalResult
          })
          self.loading = false
          self.$emit('change', {
            field: self.extra.field,
            keyInput: self.keyInput
          })
          return
        } else {
          let locationType = self.extra.field.charAt(0).toUpperCase() + self.extra.field.substr(1)
          self.$store.commit('rsvpDetails/set' + locationType, finalResult)

          let data = {
            lat: finalResult.lat,
            lng: finalResult.lng,
            brandId: self.extra.brandId
          }
          self.$sdk.get('/geofences/', data, res => {
            self.loading = false
            if (!res.error) {
              if (res.list.length <= 0) {
                self.$emit('change', {
                  field: self.extra.field,
                  keyInput: self.keyInput
                })
                return
              }

              let result = res.list[0]
              self.$store.commit('rsvpDetails/setAirportCode', '')

              if (result.type === 'airport') {
                self.$store.commit('rsvpDetails/setAirportCode', result.airportCode)

                if (self.extra.field === 'pickup') {
                  self.$store.commit('rsvpDetails/setIsAirportPickup', result.type === 'airport')
                } else{
                  self.$store.commit('rsvpDetails/setIsAirportDropoff', result.type === 'airport')
                }
              }

              self.$emit('change', {
                field: self.extra.field,
                keyInput: self.keyInput
              })
            }
          })
        }
      })
    },
    clickOut () {
      let self = this
      self.clickOutDelay = setTimeout(function () {
        self.$emit('change', {
          field: self.extra.field,
          keyInput: self.keyInput
        })
        self.showSuggestion = false
      }, 200)
    },
    extraStopAddress (x) {
      return x && x.lat && x.lng ? `${x.address2} ${x.address1}, ${x.city}, ${x.state} ${x.zipCode}` : ''
    }
  },
  watch: {
    value: function (value) {
      this.keyInput = value.title
      if (this.extra.field === 'extraStop') {
        this.keyInput = this.extraStopAddress(value)
      }
      this.initData = value.title
    },
    extra: function (value) {
      if (!value.disabled && value.field !== 'extraStop') {
        let locationType = this.extra.field.charAt(0).toUpperCase() + this.extra.field.substr(1)
        if (Object.keys(this.lastSelected).length) {
          this.$store.commit('rsvpDetails/set' + locationType, this.lastSelected)
        }
      }
    }
  },
  mounted () {
    if (this.extra.field === 'extraStop') {
      this.keyInput = this.extraStopAddress(this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.autocomplete{
  position: relative;
  width: 100%;
}

.suggestions{
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 150px;
  z-index: 2;
  list-style: none;
  overflow: auto;
  padding: 0;
  margin: 0;
  box-shadow: 1px 1px 4px rgba(0,0,0, .3);

  li{
    background: #f6f6f6;
    padding:8px 10px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    border-bottom: 1px solid #bbb;
    color: #333;

    &:last-child{ border-bottom: none; }
    i{ margin-right: 5px; }
    span{ font-size:13px; }
    .fa-exclamation-triangle{ color: #e2c84a;}
    .fa-map-marker{ color: #ea5c5c;}
    &:hover{
      background: #0D79F2;
      color: #fff;

      i{ color: #fff; }
    }
    &.empty{ cursor: default; }
  }
}

.input{
  margin: 5px 0 0;
  color: #333;
  line-height: inherit;
  transition: all .15s ease;

  &.loading{ padding-right: 40px; }
  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background: #eee; }
}

.error-msg{
  font-size: 11px;
  line-height: 1.6;
  color: #f20d0d;
  font-style: italic;
  display: block;
}

.loader{
  position: absolute;
  top: 8px;
  right: 5px;
  z-index: 2;
  color: #aaa;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/LocationInput.vue